import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StpRegistrationStorageService } from '../../../services/stp-registration-storage.service';
import { InspectorOfficer1 } from 'src/app/modules/course-accreditation/models/inspector-officer-1.model';

@Component({
  selector: 'app-inspection-officer-list',
  templateUrl: './inspection-officer-list.component.html',
  styleUrls: ['./inspection-officer-list.component.scss'],
})
export class InspectionOfficerListComponent implements OnInit {
  iscOfficerForm!: FormGroup;

  total: number;
  size: number = 10;
  page: number = 1;
  sortingKey: string = 'updated_at';
  sortingValue: string = 'descend';

  listView : any;
  inspectionOfficerList : InspectorOfficer1 = new InspectorOfficer1();

  searchingForm: FormGroup = this.fb.group({
    name: [''],
    phone: [''],
    email: [''],
    designation: ['']
  });

  stpOwnershipType: { id: number; name: string }[] = [
    { id: 1, name: 'Public' },
    { id: 2, name: 'Private' },
    { id: 3, name: 'NGO' },
    { id: 4, name: 'Others' },
  ];

  constructor(private fb: FormBuilder,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private router: Router,
    private notification: NzNotificationService,
    private activatedRoute: ActivatedRoute
    ) { }

  ngOnInit(): void {
    this.search();
  }

  search(){
    this.inspectionOfficerList.name = this.searchingForm.value.name;
    this.inspectionOfficerList.phone = this.searchingForm.value.phone;
    this.inspectionOfficerList.email = this.searchingForm.value.email;
    this.inspectionOfficerList.designation = this.searchingForm.value.designation;
    this.inspectionOfficerList.size = 10;
    this.inspectionOfficerList.page = 0;
    this.inspectionOfficerList.sortingKey = this.sortingKey;
    this.inspectionOfficerList.sortingValue = this.sortingValue;
    this.getOfficersList();
  }

  getOfficersList(){
    this.stpRegistrationStorageService.getIscOfficerList(this.inspectionOfficerList).subscribe({
      next: (response: any) =>{
        this.listView = response?.data?.content;
        this.total = response?.data?.totalElements;

        if(!response.success){
          this.notification.error('Failed!', 'Unable to find any data!');
        }
      },
      error: (error: string) => this.notification.error('Failed', error),
    });
  }

  reset() {
    this.searchingForm.reset();
    this.search();
  }

  onEdit(id: number): void {
    this.router.navigate(['/home/stp-registration/add-inspection-officer/'+ id], {
      relativeTo: this.activatedRoute
    });
  }

  // onDelete(id?: number): void {
  //   this.stpRegistrationStorageService.deleteMinistry(id).subscribe({
  //     next: (response) => {
  //       if (response.success) {
  //         this.notification.success('Success!', response.message);
  //         this.getOfficersList();
  //       } else if (response.success == false) {
  //         this.notification.error('error!', response.message);
  //       }
  //     },

  //     error: (error) => this.notification.error('Failed', error),
  //   });
  // }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.page = params.pageIndex;
    this.size = params.pageSize;

    params.sort.forEach((element: { value: string | null; key: string }) => {
      if (element.value != null) {
        this.sortingKey = element.key;
        this.sortingValue = element.value;
      }
    });

    // if (this.sortingKey != null && this.sortingValue != null) {
    //   switch(this.sortingKey){
    //     case "name":
    //      case "name" :
    //       this.stringTypeSorting(this.sortingKey, this.sortingValue);
    //       break;
    //   }
    // }

    this.inspectionOfficerList.size = this.size;
    this.inspectionOfficerList.page = this.page - 1;
    this.inspectionOfficerList.sortingKey = this.sortingKey;
    this.inspectionOfficerList.sortingValue = this.sortingValue;
    this.getOfficersList();
  }

  stringTypeSorting(sortKey: string, sortVal: string) {
    this.listView.sort((a: any, b: any) => {
      let occupationA = a[sortKey];
      let occupationB = b[sortKey];

      if (sortVal == "ascend") {
        return occupationA.toLowerCase() < occupationB.toLowerCase() ? 1 : -1;
      }else if (sortVal == "descend") {
        return occupationA.toLowerCase() > occupationB.toLowerCase() ? 1 : -1;
      }else {
        return occupationA.toLowerCase() < occupationB.toLowerCase() ? 1 : -1;
      }
    });
  }
}
